module.exports = __webpack_public_path__ + "img/qfpay-logo.18802edf.jpg";